import { useState, useCallback } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { OilChangeCalculations } from '../../../types/oilChangeCalculationTypes';
import { WindshieldWiperChangeCalculationType } from '../../../types/windshieldChangeCalculationTypes';

export enum ProductType {
  OILCHANGE = 'oilchange',
  WINDSHIELD = 'windshield',
}
interface Props {
  productType: ProductType;
  licensePlateNumber?: string;
  centerId?: string;
}

interface ReturnType {
  calculate: () => void;
  calculation?: OilChangeCalculations | WindshieldWiperChangeCalculationType;
  isLoading: boolean;
  error: boolean;
}

export const useProductChangeCalculator = ({ productType, licensePlateNumber, centerId }: Props): ReturnType => {
  const [calculation, setCalculation] = useState<
    OilChangeCalculations | WindshieldWiperChangeCalculationType | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const calculate = useCallback(async () => {
    if (licensePlateNumber && !isLoading) {
      setIsLoading(true);
      try {
        const url =
          productType === ProductType.OILCHANGE
            ? ApiPaths[ApiType.apimNafNoApi].nafCentersOilChange(licensePlateNumber.trim())
            : ApiPaths[ApiType.apimNafNoApi].nafCentersWindshieldWiper(licensePlateNumber.trim());

        const params = centerId ? { centerId } : undefined;

        const res = await apiClient.get<OilChangeCalculations | WindshieldWiperChangeCalculationType>(
          ApiType.apimNafNoApi,
          {
            url,
            params,
          },
        );
        setIsLoading(false);
        setCalculation(res.data);
        setError(false);
      } catch (e) {
        setIsLoading(false);
        setError(true);
      }
    }
  }, [centerId, isLoading, licensePlateNumber, productType]);

  return { calculate, calculation, isLoading, error };
};
